export default {"src":"/_next/static/media/shh.2c7e48e2.svg","height":544,"width":543,"blurWidth":0,"blurHeight":0};